/**
 * @param {$axios实例} $axios
 * @param {请求配置} opt{
 *                      requestType请求类型：1:带有token认证的请求,并且使用弹窗loading
 *                                          2:带有token认证的请求,并且使用弹窗loading,401特殊处理
 *                                          3:一般请求,并且使用弹窗loading
 *                                          4:带有token认证的请求，无loading,401特殊处理
 *                                          5:带有token认证的请求，无loading
 *                                          6:一般请求，无loading,
 *                      url：请求url,
 *                      param:请求参数
 *                  }
 */
/**
   AaronXue <xch1523480@gmail.com>
   2018.4.26
   二次封装axios请求,添加loading
   通过qs.stringify()将对象 序列化成URL的形式，以&进行拼接
*/
import axios from 'axios'
import { getCookie, clearCookie, initLogin, getWXEvn, isWeixin } from './index'
import { Toast, Dialog } from 'vant';
import wx from "@/assets/js/jweixin-1.6.0";

const http = options => {
  let $Toast = null
  return new Promise((resolve, reject) => {
    const defaultOptions = {};
    const newOptions = {
      ...defaultOptions,
      ...options
    };
    switch (newOptions.requestType) {
      case 1:
      case 3:
        $Toast = Toast.loading({
          duration: 0,
          message: '请求中...',
          forbidClick: true,
        });
        break;
      case 2:
      case 4:
      case 5:
      case 6:

        break;
    }
    //headers默认传递json格式数据，这里也可以设置token，每次调用都会携带
    newOptions.headers = Object.assign({
      'content-Type': 'application/json;charset=UTF-8',
      'PLATFORM': 'webH5',
      'VERSION': '3.0.19'
    }, (newOptions.headers || {}));
    if (newOptions.requestType !== 3 && newOptions.requestType !== 6) {
      newOptions.headers['access_token'] = getCookie('token')
    }
    //这里可以在调用的时候看到你的method、url、data、headers等参数
    //console.log(newOptions);
    axios({
      method: newOptions.method,
      url: newOptions.url,
      data: newOptions.data,
      params: newOptions.params,
      headers: newOptions.headers,
      responseType: newOptions.responseType,
    }).then(res => {
      //根据返回的状态码判断，注意res返回的并不一定都是status，比如小程序就是statusCode
      switch (newOptions.requestType) {
        case 1:
        case 3:
          $Toast.clear()
          break;
        case 2:
        case 4:
        case 5:
        case 6:
          break;
      }
      if (res.status === 200) {
        //这里我们只需要获取返回的data中的数据即可
        resolve(res.data);
      } else {
        Dialog.alert({
          title: '温馨提示',
          message: res.data.message || '请求失败',
          confirmButtonColor: "#fb3e47",
        })
        reject(res);
      }
    }).catch(err => {
      if (newOptions.requestType === 1 || newOptions.requestType === 3) {
        $Toast.clear()
      }
      if (err === undefined || err.code === 'ECONNABORTED') {
        Dialog.alert({
          title: '温馨提示',
          message: '服务请求超时',
          confirmButtonColor: "#fb3e47",
        })
        reject(err)
        return
      }
      const status = err.response.status
      switch (status) {
        case 400:
        case 404:
        case 406:
        case 410:
        case 422:
          Dialog.alert({
            title: '温馨提示',
            message: '发出的请求有错误',
            confirmButtonColor: "#fb3e47",
          })
          break;
        case 401:
        case 403:
          clearCookie('token')
          const loginCfg = {
          }
          if (newOptions.hasOwnProperty('scope')) {
            loginCfg.scope = newOptions.scope
          }
          if (newOptions.hasOwnProperty('isForce')) {
            loginCfg.isForce = newOptions.isForce
          }
          if (newOptions.hasOwnProperty('onlyWX')) {
            loginCfg.onlyWX = newOptions.onlyWX
          }
          if (newOptions.hasOwnProperty('callBackUrl')) {
            loginCfg.callBackUrl = newOptions.callBackUrl
          }
          if (newOptions.hasOwnProperty('needLoginModal')) {
            loginCfg.needLoginModal = newOptions.needLoginModal
          }
          if (newOptions.hasOwnProperty('loginSuccess')) {
            loginCfg.success = newOptions.loginSuccess
          } else {
            loginCfg.success = function () {
              location.reload()
            }
          }
          if (newOptions.requestType === 2 || newOptions.requestType === 4) {
            if (newOptions.hasOwnProperty('loginFail')) {
              loginCfg.fail = newOptions.loginFail
            }
          }
          if (isWeixin()) {
            getWXEvn({
              //如果是小程序
              isMiniApp: () => {
                const str = location.href; //取得整个地址栏
                const strList = str.split("?");
                const arr = strList[1] ? strList[1].split("&").filter(item => {
                  return !(item.includes('access_token') || item.includes('userId'))
                }) : []
                wx.miniProgram.navigateTo({
                  url: `/pages/authorize/authorize?from=commonh5&redirectUrl=${strList[0]}?${arr.join('&')}`,
                });
              },
              //如果是公众号网页
              isWeixinNotMiniApp: () => {
                initLogin(loginCfg)
              }
            });
          } else {
            initLogin(loginCfg)
          }
          // initLogin(loginCfg)
          break;
        case 500:
        case 502:
        case 503:
        case 504:
          Dialog.alert({
            title: '温馨提示',
            message: '服务器发生错误!',
            confirmButtonColor: "#fb3e47",
          })
          break;
        default:
          break;
      }
      console.log(err)
      reject(err);
    })
  })
}

/**
 * @param {请求url} url
 * @param {请求参数} data
 */


const get = opt => {
  if (!opt.data) {
    opt.data = {}
  }
  opt.params = opt.data
  opt.data = {}
  if (!opt.hasOwnProperty('requestType')) {
    opt.requestType = 1
  }
  // opt.params.v = new Date().getTime()
  // opt.data.v = new Date().getTime()
  return http({
    //这里是你自己的请求方式、url和data参数
    method: 'get',
    ...opt

  })
}
const post = opt => {
  if (!opt.data) {
    opt.data = {}
  }
  if (!opt.hasOwnProperty('requestType')) {
    opt.requestType = 1
  }
  // opt.data.v = new Date().getTime()
  return http({
    //这里是你自己的请求方式、url和data参数
    method: 'post',
    ...opt
  })
}
export {
  get,
  post
}
